module.exports = __webpack_public_path__ + "img/42.65f0fefd.jpg";